import * as React from "react";

import Header from "@/Components/Headers/Components/Header";

function MessagingHeader(): React.JSX.Element {
  return (
    <Header
      tabs={[{ isActive: true, onPress: (): void => {}, title: "Messages" }]}
      rightComponent={<></>}
    />
  );
}

export default MessagingHeader;
